import type { Dayjs } from "dayjs";

export interface IScheduleDay {
	author_id: number | null;
	finish: string | null;
	finish_limit: string | null;
	id: number;
	installer_id: number;
	isWeekend: boolean | null;
	is_manager: boolean;
	start: string | null;
	start_limit: string | null;
	vacation: boolean;
	timeslots: Timeslot[];
	trip: boolean;
	point_start: PointCoordinates | null;
	old_date: string;
	old_start: string;
	old_finish: string;
}

export type PointCoordinates = { x: number | null; y: number | null };

export type timeslotType = "SR" | "Dost" | "Vid" | "PZ";

export interface Timeslot {
	address?: string;
	arrival?: string | null;
	author_id?: number;
	bitrix?: string | null;
	city?: string;
	created?: number;
	day_id?: number;
	finish?: string;
	type?: timeslotType[] | string[];
	id?: number;
	score?: number;
	start?: string;
	tasks?: Tasks;
	updated?: number;
	booking?: boolean;
	count_of_cars?: number | null;
	amo?: string | null;
	outside?: boolean;
	color?: string | null;
	coordinates?: string;
	x: number | null;
	y: number | null;
	skiping?: boolean;
	type_timeslot?: string;
	additional_timeslots_ids?: number[];
	overwork: boolean;
	is_special?: boolean;
	text?: string
	old_date?: string;
	old_start?: string;
	old_finish?: string;
}

export interface Tasks {
	task_ids?: number[];
}

export interface InstallerSchema {
	isLoading?: boolean;
	isLoadingNextMonth: boolean;
	isLoadingPrevMonth: boolean;
	error?: string;
	ids: string[];
	currentFetchedStart?: Dayjs;
	currentFetchedData?: Dayjs;
	dates?: Record<string, string | Partial<IScheduleDay>>;
	entities: Record<string, IInstaller>;
	inActiveEntities: Record<string, IInstaller>;
	sidebarStatus: Record<string, boolean>;
}

export interface IInstaller {
	id: number;
	name: string;
	surname?: string;
	is_manager?: boolean;
	workPlace: WorkPlaces;
	days: Record<string, IScheduleDay>;
	departmentId?: number;
    enabled: boolean;
}

export interface IInstallerWithDay {
	id: number;
	name: string;
	surname?: string;
	is_manager?: boolean;
	workPlace: WorkPlaces;
	day: IScheduleDay;
	departmentId?: number;
}
export type ScheduleType = "daily" | "shift";

interface ScheduleBase {
	type?: ScheduleType;
	active: string;
	author_id?: number;
	created?: number;
	id?: number;
	installer_id?: number;
	is_manager?: boolean;
	updated?: number;
}

interface DailyScheduleRules {
	days: Record<string, string[]>;
	start_day: string;
}

interface ShiftScheduleRules {
	finish: string;
	shift: string;
	start: string;
	start_day: string;
}

export interface UnknownSchedule extends ScheduleBase {
	rules: unknown;
}

export interface DailySchedule extends ScheduleBase {
	rules: DailyScheduleRules;
	type: "daily";
}

export interface ShiftSchedule extends ScheduleBase {
	rules: ShiftScheduleRules;
	type: "shift";
}

export enum WorkPlaces {
	SPB = "SPB",
	MSK = "MSK",
	OTHER = "OTHER",
}
